// src/components/ProtectedRoute.js
import React, { useEffect, useState } from 'react'
import { Navigate, useLocation } from 'react-router-dom'
import { supabase } from '../supabaseClient'

function ProtectedRoute({ children, allowedRoles = [] }) {
  const [user, setUser] = useState(null)
  const [loading, setLoading] = useState(true)
  const location = useLocation()

  useEffect(() => {
    const fetchUserAndRole = async () => {
      const {
        data: { session },
      } = await supabase.auth.getSession()

      if (!session?.user) {
        setLoading(false)
        return
      }

      const { data: userRecord, error } = await supabase
        .from('users')
        .select('role')
        .eq('id', session.user.id)
        .single()

      if (error) {
        console.error('Error fetching user role:', error)
        setLoading(false)
        return
      }

      // Default to 'viewer' if role missing, but normally it should be set
      const role = userRecord?.role || 'pending'

      setUser({ ...session.user, role })
      setLoading(false)
    }

    fetchUserAndRole()
  }, [])

  if (loading) {
    return (
      <div className="p-4 text-center text-slate-600">
        Checking session...
      </div>
    )
  }

  // Not logged in → send to login
  if (!user) {
    return <Navigate to="/login" state={{ from: location }} replace />
  }

  // 🚫 Pending users: they should ONLY ever see the access-pending page
  if (user.role === 'pending') {
    // No matter what protected route they try, send them to /access-pending
    return <Navigate to="/access-pending" replace />
  }

  // Role is not allowed for this route → send to Ask Riq (or wherever you want)
  if (allowedRoles.length > 0 && !allowedRoles.includes(user.role)) {
    return <Navigate to="/ask-riq" replace />
  }

  // ✅ Authenticated and allowed
  return children
}

export default ProtectedRoute
